<template>
    <div>
        <b-card :header="uLang('app.edit')" header-tag="h4" class="bg-default-card">
            <trajectory-enrolment-form
                v-if="relation"
                :id="id"
                :relation="relation"
                :override-endpoint="overrideEndpoint"
            />
        </b-card>
    </div>
</template>

<script>
    import TrajectoryEnrolmentForm from '~/components/forms/admin/relation/trajectory-enrolment/form'

    export default {
        name: 'edit',
        props: {
            id: {
                required: true,
            },
            relationId: {
                required: true,
            },
        },

        data() {
            return {
                relation: null,
            }
        },

        created() {
            this.retrieveRelation();
        },

        methods: {
            async retrieveRelation() {
                let {data} = await window.axios.get(route('relations.show', {relation: this.relationId}));
                this.relation = data;
            },
        },

        components: {
            'trajectory-enrolment-form': TrajectoryEnrolmentForm,
        },

        computed: {
            overrideEndpoint() {
                return route('relations.trajectory-enrolments.store', { relation: this.relationId })
            }
        },
    }
</script>

<style lang="css" scoped>
</style>
